<template>
  <div class="plugin-wrap text__simple" v-if="config && config.text">
    <div class="layout author__name">
      <div class="quote-author col-xs-12">{{config.text}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TxtSimple",
  props: {
    config: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.author__name { text-align: center; }
.quote-author {
  margin-top: 1.25rem;
  letter-spacing: .04688rem;
  font-size: .8125rem;
  line-height: 1;
  font-weight: 600;
  color: #000;
}

@media screen and (min-width: 48em) {
  .quote-author {
    font-size: 1.25rem;
    letter-spacing: .0625rem;
    margin-top: 2.625rem;
  }
}

@media screen and (min-width: 75em) {
  .quote-author {
    margin-top: 3.625rem;
  }
}
</style>